import { REACT_APP_ADHESION_API_URL } from "../constants/env";
import { ApiService } from "./ApiService";

export class QRCodeService {
  private static instance: QRCodeService;
  private readonly api: ApiService;

  private constructor() {
    this.api = new ApiService(REACT_APP_ADHESION_API_URL);
  }

  public static getInstance(): QRCodeService {
    if (!this.instance) {
      this.instance = new QRCodeService();
    }

    return this.instance;
  }

  async generateQRCode(telMobile: string, immat: string): Promise<string> {
    try {
      const command = { telMobile: telMobile, immat: immat };
      const url = "/SignatureElectronique/qr-code";
      const response = await this.api.post<any>(url, command);
      if (response) {
        return response;
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      console.error("Error generating QR code:", error);
      throw error;
    }
  }
}
